
      <div class="k-progressbar" [@progressState]="showProgress">
        <span class="k-progress" [style.width]="progressComplete + '%'"></span>
      </div>
      <span class="k-multiple-files-group-wrapper">
        <span class="k-file-group k-icon k-i-copy"></span>
      </span>
      <span class="k-multiple-files-wrapper">
        <ng-container *ngIf="!fileInfoTemplate">
          <span *ngFor="let file of files" class="k-file-name-size-wrapper">
            <span [title]="file.name" class="k-file-name">
                {{file.name}}
            </span>
            <span [ngClass]="{
                    'k-text-error': file.validationErrors,
                    'k-file-validation-message': file.validationErrors,
                    'k-file-size': !file.validationErrors
                  }"
            >{{fileStatusText(file)}}</span>
          </span>
          <span class="k-file-information"
            [ngClass]="{
              'k-text-success': isUploadSuccessful,
              'k-text-error': isUploadFailed
            }"
          >{{batchStatusText}}</span>
        </ng-container>
        <ng-template *ngIf="fileInfoTemplate"
            [templateContext]="{
              templateRef: fileInfoTemplate.templateRef,
              state: files[0].state,
              $implicit: files
            }">
        </ng-template>
      </span>
      <kendo-upload-file-list-item-action-button
        [file]='files[0]'
        [disabled]='disabled'
        [progress]='progressComplete'>
      </kendo-upload-file-list-item-action-button>
    